import Video from "./video";

export { Video };
